import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";
import "@fancyapps/fancybox";
import { axiosInstance } from "../../Config";
import { toast } from "react-toastify";

const ReligiousList = () => {
    const [religions, setReligions] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [dateFilter, setDateFilter] = useState("all");
    const [selectedReligion, setSelectedReligion] = useState(null);
    const [loading, setLoading] = useState(false);
    const limit = 10;
    const navigate = useNavigate();


    const dateFilters = [
        { value: "all", label: "All Data" },
        { value: "7", label: "Last 7 Days" },
        { value: "30", label: "This Month" },
        { value: "180", label: "Last 6 Months" },
        { value: "365", label: "Last Year" },
    ];

    useEffect(() => {
        const t = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm.trim());
        }, 500);

        return () => clearTimeout(t);
    }, [searchTerm]);

    useEffect(() => {
        fetchData(currentPage, searchTerm, dateFilter);
    }, [currentPage, debouncedSearchTerm, dateFilter]);

    const fetchData = async (page, search = "", filter = "all") => {
        setLoading(true)
        try {
            const response = await axiosInstance.get(
                `/getAllReligious?page=${page}&limit=${limit}&search=${encodeURIComponent(
                    search
                )}&dateFilter=${filter}`
            );
            if (response.data.success) {
                setReligions(response?.data?.body?.data);
                setTotalPages(response?.data?.body?.totalPages);

            } else {

            }
        } catch (error) {

        } finally {
            setLoading(false)
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleDateFilter = (filterValue) => {
        setDateFilter(filterValue);
        setCurrentPage(1);
    };

    const getCurrentFilterLabel = () => {
        const filter = dateFilters.find((f) => f.value === dateFilter);
        return filter ? filter.label : "All Data";
    };

    const deleteReligion = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                await axiosInstance.post(`/religiousDelete/${id}`);
                toast.success("Religious Belief deleted Successfuly")

                setTimeout(() => {
                }, 1200)
                const response = await axiosInstance.get(
                    `/getAllReligious?page=${currentPage}&limit=${limit}&search=${encodeURIComponent(
                        debouncedSearchTerm
                    )}&dateFilter=${dateFilter}`
                );

                if (response.data.success) {
                    const newTotalPages = response?.data?.body?.totalPages;
                    const newData = response?.data?.body?.data;
                    if (newData.length === 0 && currentPage > 1) {
                        setCurrentPage((prevPage) => prevPage - 1);
                    } else {
                        setReligions(newData);
                        setTotalPages(newTotalPages);
                    }

                }
            } catch (error) {
                Swal.fire(
                    "Error!",
                    error.response?.data?.message || "Error deleting Religious Belief",
                    "error"
                );
            }
        }
    };

    const handleViewDetails = (religion) => {
        setSelectedReligion(religion);
    };
    const handleUpdate = (id) => {
        navigate(`/updateReligious/${id}`)
    }

    return (
        <>
            <div id="layout-wrapper">
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="title-box mb-3 pb-1">
                                <h4 className="mb-0 page-title">Religious Belief List</h4>
                                <nav aria-label="breadcrumb" className="mt-1">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard" className="new">
                                                <i className="ri-home-4-fill me-1" /> Home
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/religiousList" className="new">
                                                 Religious
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Religious Belief Listings
                                        </li>
                                    </ol>
                                </nav>
                            </div>

                            <div className="card">
                                <div className="card-body cusbar">

                                    <div className="card-head mb-3 d-flex justify-content-between align-items-center">
                                        <div className="d-flex">
                                            <div className="tbl-search position-relative me-2">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search.."
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                                <i className="ri-search-line" />
                                            </div>

                                            <div className="dropdown tbl-drop">
                                                <button
                                                    className="btn btn-light dropdown-toggle"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    {getCurrentFilterLabel()}
                                                </button>
                                                <ul className="dropdown-menu">
                                                    {dateFilters.map((filter) => (
                                                        <li key={filter.value}>
                                                            <button
                                                                className="dropdown-item"
                                                                type="button"
                                                                onClick={() => handleDateFilter(filter.value)}
                                                            >
                                                                {filter.label}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <Link
                                                to='/addReligious'
                                                className="btn btn-success me-2"
                                            >
                                                Add Religious Belief
                                            </Link>

                                        </div>

                                    </div>


                                    <div className="table-responsive table-card border-top">
                                        <div
                                            data-simplebar=""
                                            className="cus-scroll scmob"
                                        >
                                            <table className="table table-centered cus-nowrap align-middle hltr mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sr no.</th>
                                                        <th>Name</th>

                                                        <th className="text-end">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {religions.length > 0 ? (
                                                        religions.map((religion, index) => (
                                                            <tr key={religion?.id}>
                                                                <td>{(currentPage - 1) * limit + index + 1}</td>
                                                                <td>{religion?.name || ""}</td>

                                                                <td>
                                                                    <div className="d-flex justify-content-end">
                                                                        {/* <button
                                                                            type="button"
                                                                            className="btn btn-soft-primary px-2 btn-sm me-1"
                                                                            data-bs-toggle="offcanvas"
                                                                            data-bs-target="#view-details"
                                                                            aria-controls="offcanvasRight"
                                                                            onClick={() => handleViewDetails(religion)}
                                                                        >
                                                                            <i className="ri-eye-fill font-size-16"></i>
                                                                        </button> */}
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-soft-primary px-2 btn-sm me-1"
                                                                            data-bs-toggle="offcanvas"
                                                                            data-bs-target="#view-details"
                                                                            aria-controls="offcanvasRight"
                                                                            onClick={() => handleUpdate(religion?.id)}
                                                                        >
                                                                            <i className="ri-pencil-fill font-size-16"></i>
                                                                        </button>

                                                                        <button
                                                                            onClick={() => deleteReligion(religion?.id)}
                                                                            className="btn btn-soft-danger px-2 btn-sm"
                                                                            style={{
                                                                                backgroundColor: "#ea5455",
                                                                                borderColor: "#ea5455",
                                                                                color: "#fff",
                                                                            }}
                                                                            title="Delete"
                                                                        >
                                                                            <i className="ri-delete-bin-line font-size-16"></i>{" "}
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        !loading && <tr>
                                                            <td
                                                                colSpan="6"
                                                                style={{ textAlign: "center", padding: "20px" }}
                                                            >
                                                                No Religious Belief found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            {totalPages && totalPages > 1 ?
                                                <div className="d-flex justify-content-center align-items-center mt-3 ">
                                                    <Stack
                                                        spacing={2}
                                                        className="d-flex justify-content-center mt-3"
                                                    >
                                                        <Pagination
                                                            count={totalPages}
                                                            page={currentPage}
                                                            onChange={handlePageChange}
                                                            color="error"
                                                        />
                                                    </Stack>
                                                </div>
                                                : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* religion Details Offcanvas */}
            {/* <div
                className="offcanvas offcanvas-end rdetails"
                tabIndex="-1"
                id="view-details"
                aria-labelledby="offcanvasRightLabel"
            >
                <div className="offcanvas-header d-block">
                    <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center">
                            <h5
                                className="offcanvas-title mb-0 me-3 fw-semibold"
                                id="offcanvasRightLabel"
                            >
                                Religious Belief Details
                            </h5>
                        </div>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                </div>
                <div className="offcanvas-body">
                    {selectedReligion ? (
                        <>
                            <table
                                className="table table-borderless"
                                style={{ marginLeft: "-8px" }}
                            >
                                <tbody>
                                    <tr>
                                        <td>Religious Belief Name :</td>
                                        <td className="text-end text-black fw-medium">
                                            {selectedReligion?.name || ""}
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                        </>
                    ) : (
                        <div className="text-center py-5">
                            <i className="ri-user-line font-size-48 text-muted"></i>
                            <p className="mt-3 text-muted">No Religious Belief selected</p>
                        </div>
                    )}
                </div>
            </div> */}
            
            {loading && (
                <div className="loader" style={{ position: 'absolute', top: '50%', left: '59%', transform: 'translate(-50%, -50%)' }}>
                    <div className="spinner-border" role="status" style={{ width: '50px', height: '50px', color: "#963F02" }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default ReligiousList;
